export enum IntegrationConnectionsEnum{
    XeroConnection,
    XpmConnection,
    AnnatureConnection,
    DocuSignConnection,
}